import { request } from '@/api/request'
import GlobalConfig from '@/global/config'

const checkResponse = res => {
  return new Promise((resolve, reject) => {
    if (res.status >= 200 && res.status < 300) {
      resolve(res.data)
    }
    reject(res.data)
  })
}

// 企业端：企业资金
export function getCompanyCaptial(params) {
  return request({
    url: `/api/company/captial?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get',
    params
  }).then(checkResponse)
}

// 用户端：个人钱包
export function getCustomerCaptial() {
  return request({
    url: `/api/customer/captial?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get'
  }).then(checkResponse)
}

// 交易记录列表
export function getTransactionList(params) {
  return request({
    url: `/api/transaction/list?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get',
    params
  }).then(checkResponse)
}

// 用户端/企业端：银联支付交易列表
export function transactionYinLianListApi(params) {
  return request({
    url: `/api/transactionUnipay/list?companyId=${GlobalConfig.getCompanyId()}&token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get',
    params
  }).then(checkResponse)
}

// 交易记录渠道
export function tradeRecordChanelApi() {
  return request({
    url: `/api/transaction/channel?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get'
  }).then(checkResponse)
}

// 交易记录类型
export function tradeRecordTypeApi(params) {
  return request({
    url: `/api/transaction/type?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get',
    params
  }).then(checkResponse)
}

// 企业端：短信钱包详细
export function textMessageInfoApi(params) {
  return request({
    url: `/api/captialMessage/info/company?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get',
    params
  }).then(checkResponse)
}

// 获取支付二维码
export function getQrCodeData(params) {
  return request({
    url: `/api/transaction/weixin/pay?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'post',
    params
  }).then(checkResponse)
}

// 用户内部转移可用资金专用
export function userInnerFundTransfer(data) {
  return request({
    url: `/api/freezes/balance/reward?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'post',
    data
  }).then(checkResponse)
}

// 用户端：红包提现检测
export function withdrawalTest() {
  return request({
    url: `/api/customer/cash/check?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get'
  }).then(checkResponse)
}

// 用户端：当日提现详细
export function getWeChatCashOutInfo() {
  return request({
    url: `/api/customer/cash/out/daily/info?token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'get'
  }).then(checkResponse)
}

// 微信提现(不支持验证码)
export function weChatCashOut(cash) {
  return request({
    url: `/api/customer/cash/out?cash=${cash}&token=${GlobalConfig.getBaseToken()}&t=${Date.now()}`,
    method: 'post'
  }).then(checkResponse)
}
